import React from "react"

import PropTypes from "prop-types"
import { FlatList } from "react-native"

import RecommendedItem from "./RecommendedItem"
import { RecommendationStyles } from "./gameplansStyles"

const RecommendationList = ({
  recommendations,
  onSelectRecommendation,
  numberOfPeople,
}) => {
  const renderItem = ({ item }) => {
    return (
      <RecommendedItem
        item={item}
        onSelectRecommendation={onSelectRecommendation}
        numberOfPeople={numberOfPeople}
      />
    )
  }

  return (
    <FlatList
      data={recommendations}
      renderItem={renderItem}
      keyExtractor={item => item.id}
      style={RecommendationStyles.flatlist}
    />
  )
}

export default RecommendationList

RecommendationList.propTypes = {
  recommendations: PropTypes.array,
  onSelectRecommendation: PropTypes.func,
  item: PropTypes.object,
  numberOfPeople: PropTypes.number,
}
